import DOMPurify from 'dompurify';

// Helper to check if content is effectively empty
export function isQuillContentEmpty(html) {
  const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();
  return clean === '';
}